// Backend identifiers. These values travel over the wire and are compared against data
// returned by the API, so they must stay in Polish and must NEVER be translated.
// Translate only at render time, through the i18n keys listed next to each entry.

// Values of the `typ` field on a task (POSTed to /zadanie, switched on in Tasks/New.js
// and returned in `typyZadan` from /init). Display labels live under `tasks.types.*`.
export const TASK_TYPES = {
   DYZUR_TELEFONICZNY: "DyzurTelefoniczny",
   SPOTKANIE_INFORMACYJNE: "SpotkanieInformacyjne",
   WIZYTA_HOTELOWA: "WizytaHotelowa",
   WYCIECZKA_FAKULTATYWNA: "WycieczkaFakultatywna",
   BIURO: "Biuro",
   DAY_OFF: "DayOff",
   INNE: "Inne",
   TRANSFER: "Transfer",
   WYLOT: "Wylot",
   PRZYLOT: "Przylot",
   ANIMACJA: "Animacja"
};

// Maps a backend task type onto its i18n key, so the same enum renders correctly in the
// new-task dropdown and in the report filter (which receives raw enums from /init).
export const TASK_TYPE_LABEL_KEYS = {
   [TASK_TYPES.DYZUR_TELEFONICZNY]: "tasks.types.dyzurTelefoniczny",
   [TASK_TYPES.SPOTKANIE_INFORMACYJNE]: "tasks.types.spotkanieInformacyjne",
   [TASK_TYPES.WIZYTA_HOTELOWA]: "tasks.types.wizytaHotelowa",
   [TASK_TYPES.WYCIECZKA_FAKULTATYWNA]: "tasks.types.wycieczkaFakultatywna",
   [TASK_TYPES.BIURO]: "tasks.types.biuro",
   [TASK_TYPES.DAY_OFF]: "tasks.types.dayOff",
   [TASK_TYPES.INNE]: "tasks.types.inne",
   [TASK_TYPES.TRANSFER]: "tasks.types.transfer",
   [TASK_TYPES.WYLOT]: "tasks.types.wylot",
   [TASK_TYPES.PRZYLOT]: "tasks.types.przylot",
   [TASK_TYPES.ANIMACJA]: "tasks.types.animacja"
};

// Human-readable task names as delivered by the welcome-print endpoint
// (/wydruk/serdeczniewitamy -> zadania[].nazwa). printerHelper.js switches on these to
// decide which PDF table row to build - translating them silently breaks PDF generation.
export const PRINT_TASK_NAMES = {
   SPOTKANIE_INFORMACYJNE: "Spotkanie informacyjne",
   WIZYTA_HOTELOWA: "Wizyta hotelowa",
   DYZUR_TELEFONICZNY: "Dyżur telefoniczny"
};

// Value of `uzytkownik.typKonta` marking an entertainer row in the scheduler grid.
export const ACCOUNT_TYPE_ANIMATOR = "Animator";
